import React from 'react';

export const GOOGLE_PLAY = 'https://play.google.com/store/apps/details?id=com.mysky.oceanapp';
export const APP_STORE = 'https://apps.apple.com/ru/app/myocean-crewapp/id1576354367?l=en';
